import { Injectable } from '@angular/core';
import { Camera, CameraOptions, PictureSourceType } from '@ionic-native/camera';
import Compressor from 'compressorjs';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from './request.service';

declare const Ionic: any;

@Injectable()
export class PhotoService {

	constructor(
		private camera: Camera,
		private requestService: RequestService
	) { }

	getImage(isApp: boolean, sourceType: PictureSourceType, eventInput?: any): Promise<string> {
		return new Promise((resolve, reject) => {
			if (isApp) {
				const options: CameraOptions = this.optionsByType(sourceType);
				this.camera.getPicture(options).then((imageUrl: string) => {
					console.log(imageUrl);
					this.getBase64FromFilePath(imageUrl).then((base64: string) => {
						resolve(base64);
					});
				}, (error) => {
					console.log(error);
					reject();
				});
			} else {
				// tslint:disable-next-line:no-unused-expression
				new Compressor(eventInput.target.files[0], {
					quality: 0.8,
					convertSize: 50000, //50kb - imagens png que tiverem mais de 50kb, são convertidos para jpg
					maxHeight: 1366,
					maxWidth: 1366, // (16:9)
					success: (result) => {
						console.log(result);
						this.getBase64FromBlob(result).then((base64: string) => {
							resolve(base64);
						});
					},
					error: (err) => {
						console.log(err);
						reject();
					}
				});
			}
		});
	}

	deletePhoto(photoId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.deleteData(APP_CONFIG.WEBSERVICE.PHOTOS + photoId).then((response: any) => {
				resolve(response);
			}, (error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	private getBase64FromFilePath(path: string): Promise<string | ArrayBuffer> {
		return new Promise((resolve, reject) => {
			try {
				path = Ionic.WebView.convertFileSrc(path);
				const xhr: XMLHttpRequest = new XMLHttpRequest();
				xhr.onload = () => {
					const reader: FileReader = new FileReader();
					reader.onloadend = () => {
						resolve(reader.result);
					};
					reader.readAsDataURL(xhr.response);
				};
				xhr.open('GET', path);
				xhr.responseType = 'blob';
				xhr.send();
				xhr.onerror = (error) => {
					console.error(JSON.stringify(error));
					reject(error);
				};
			} catch (error) {
				console.error(JSON.stringify(error));
				reject(error);
			}
		});
	}

	private getBase64FromBlob(file: Blob): Promise<string | ArrayBuffer> {
		return new Promise((resolve) => {
			const reader: FileReader = new FileReader();
			reader.onloadend = (ev) => {
				resolve(reader.result);
			};
			reader.readAsDataURL(file);
		});
	}

	private optionsByType(sourceType: PictureSourceType): CameraOptions {
		//TODO: avaliar se usa plugin da camera ou plugin imagePicker para pegar da galeria
		return {
			quality: 80,
			destinationType: this.camera.DestinationType.FILE_URI, // Usar file_uri para evitar problemas de memory
			sourceType: sourceType,
			targetWidth: 1366, // (16:9)
			targetHeight: 1366,
			allowEdit: false,
			encodingType: this.camera.EncodingType.JPEG, //manter JPEG devido ao tamanho do arquivo
			saveToPhotoAlbum: false,
			correctOrientation: true
		};
	}

	// TESTE:
	compressToBase64(imagePath: string): Promise<string> {
		return new Promise(async (resolve, reject) => {
			const blob: Blob = await fetch(imagePath).then((resp) => resp.blob());
			const file: File = new File([blob], "foto", { type: "image/jpeg" });
			// console.log(file);
			// tslint:disable-next-line: no-unused-expression
			new Compressor(file, {
				quality: 0.8,
				convertSize: 50000, //50kb - imagens png que tiverem mais de 50kb, são convertidos para jpg
				maxHeight: 1024,
				maxWidth: 1024,
				success: (result) => {
					console.log("Antes: " + file.size + ", depois: " + result.size);
					this.getBase64FromBlob(result).then((base64: string) => {
						resolve(base64);
					});
				},
				error: (err) => {
					console.log(err);
					reject();
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/photo.service.ts